import styled, { css, keyframes } from 'styled-components'

const borderBlinking = keyframes`
  0% {
    transform: scale(0.8);
  }

  30% {
    transform: scale(1.15);
  }

  /* 60% {
    transform: scale(0.9);
  } */

  100% {
    transform: scale(0.8);
  }
`

export const ReactTurntableSection = styled.div`
  position: relative;
  &::before,
  &::after {
    clear: both;
    content: '';
    display: table;
    zoom: 1;
  }
`

export const TurntableCanvas = styled.canvas`
  display: block;
  pointer-events: none;
`

export const TurntableButton = styled.button`
  position: absolute;
  box-sizing: content-box;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  width: 80px;
  height: 80px;
  line-height: 80px;
  border-radius: 50%;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
  /* border: 3px dotted #fff; */
  color: #fff;
  text-align: center;
  font-size: 16px;
  font-weight: bold;
  margin: auto;
  cursor: ${props => (!props.isBlankWheel ? 'pointer' : 'default')};
  z-index: 2;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
  outline: none;
  border: none;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    width: 80px;
    height: 80px;
    border-radius: 50%;
    border-top-right-radius: 0;
    transform: rotate(-45deg);
    background: ${props =>
      !props.isBlankWheel
        ? !props.spinButtonSetting?.colorOn
          ? '#222'
          : props.spinButtonSetting?.color
        : '#777'};
    z-index: 2;
  }
  &::after {
    content: '${props => props.spinButtonText}';
    position: absolute;
    width: 80px;
    height: 80px;
    border-radius: 50%;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 3;
    -webkit-tap-highlight-color: transparent;
    font-size: 16px;
    font-weight: bold;
    display: block;
    color: ${props => (!props.isBlankWheel ? '#fff' : '#ccc')};
    user-select: none;
    -webkit-text-stroke: 0.5px #f8f8f8;
    text-shadow: 0px 1px 4px #000;

    letter-spacing: 0.7px;
    ${props =>
      (props.spinButtonSetting?.imageOn || props.defaultSpinButtonImage) &&
      css`
        content: '';
        background-position: center;
        background-size: cover;
        background-repeat: no-repeat;
        background-image: url(${props =>
          props.spinButtonSetting?.imageOn
            ? props.spinButtonSetting?.image
            : props.defaultSpinButtonImage});
      `}
  }

  ${props =>
    props.buttonDown &&
    css`
      transform: translateY(1px);
    `}

  opacity: ${props => props.opacity};
`

export const ButtonText = styled.span`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  margin-top: 1.1rem;
  font-size: 11px;
  font-weight: normal;
  display: block;
  color: #fff;
  user-select: none;
  pointer-events: none;
  /* -webkit-text-stroke: 0.5px #f8f8f8;
  text-shadow: 0px 1px 4px #000; */
  letter-spacing: 0.2px;
  z-index: 3;
`

export const ButtonBg = styled.div`
  position: absolute;
  box-sizing: content-box;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  /* border: 3px dotted #fff; */
  margin: auto;
  z-index: 2;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
  background-color: #fff;
  ${props =>
    props.buttonAnimation &&
    !props.isRunning &&
    !props.buttonDown &&
    !props.isBlankWheel
      ? css`
          transform: scale(0.8);
          animation: ${borderBlinking} 2s ease-in infinite;
        `
      : css`
          transform: ${props.buttonAnimation ? 'scale(1.15)' : 'scale(1.1)'};
          background-color: ${props =>
            !props.buttonDown && props.buttonAnimation
              ? !props.isBlankWheel
                ? props.pieColor
                : '#ccc'
              : '#FFF'};
        `}
  opacity: ${props => props.opacity};
`

export const VerticalLine = styled.div`
  position: absolute;
  top: 1rem;
  left: 50%;
  transform: translateX(-50%);
  width: 2px;
  height: calc(50% - 1rem);
  background: linear-gradient(
    to bottom,
    #fff calc(100% - 100px),
    transparent 100%
  );
  z-index: 2;
  ${props =>
    props.disableTouchAction &&
    css`
      touch-action: none;
    `};
`

export const DraggableDot = styled.div`
  position: absolute;
  left: 50%;
  transform: translateX(-50%) translateY(-1rem);
  width: 15px;
  height: 15px;
  background-color: #fff;
  border-radius: 50%;
  cursor: pointer;
  top: ${props => props.top};
`

// export const TurntableButton = styled.div`
//   position: absolute;
//   box-sizing: content-box;
//   left: 0;
//   right: 0;
//   top: 0;
//   bottom: 0;
//   width: 80px;
//   height: 80px;
//   line-height: 80px;
//   border-radius: 50%;
//   box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
//   border: 2px dashed #fff;
//   color: #fff;
//   text-align: center;
//   font-size: 16px;
//   font-weight: bold;
//   margin: auto;
//   cursor: pointer;
//   z-index: 2;
//   user-select: none;
//   -webkit-tap-highlight-color: transparent;
//   ${props =>
//     !props.isRotate &&
//     css`
//       animation: ${borderBlinking} 5s linear infinite;
//     `}
//   /* box-shadow: 0px 0px 3px 0px #fff; */

//   &::before {
//     content: '';
//     position: absolute;
//     left: 0;
//     right: 0;
//     top: 0;
//     bottom: 0;
//     width: 80px;
//     height: 80px;
//     border-radius: 50%;
//     border-top-right-radius: 0;
//     transform: rotate(-45deg);
//     background: ${props =>
//       !props.spinButtonSetting.colorOn
//         ? '#3d3d3d'
//         : props.spinButtonSetting.color};
//     z-index: 2;
//   }
//   &::after {
//     content: '${props => props.spinButtonText}';
//     position: absolute;
//     width: 80px;
//     height: 80px;
//     border-radius: 50%;
//     left: 0;
//     right: 0;
//     top: 0;
//     bottom: 0;
//     z-index: 3;
//     -webkit-tap-highlight-color: transparent;
//     font-size: 16px;
//     font-weight: bold;
//     display: block;
//     color: #fff;
//     user-select: none;
//     -webkit-text-stroke: 0.5px #f8f8f8;
//     text-shadow: 0px 1px 4px #000;

//     letter-spacing: 0.5px;
//     ${props =>
//       props.spinButtonSetting.imageOn &&
//       css`
//         content: '';
//         background-position: center;
//         background-size: cover;
//         background-repeat: no-repeat;
//         background-image: url(${props => props.spinButtonSetting.image});
//       `}
//   }
//   &:active {
//     /* box-shadow: inset 1px 1px 3px #222; */
//     transform: translateY(1px);
//   }
// `
